export default "__VITE_ASSET__CkSE_DOC__"